import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	DeleteBatchRefundProcedure,
	DeleteBatchRefundProcedureResponse,
} from 'domain/usecases/private/refund/request/delete-batch-procedure';

export class RemoteRefundDeleteBatchProcedure implements DeleteBatchRefundProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteBatchRefundProcedureResponse>,
	) {}

	async delete(): Promise<DeleteBatchRefundProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
